<template>
  <li
    class="LeftNav__Item LeftNav__ItemMenuToggle block xl:hidden"
    :class="openMenu ? 'LeftNav__Item--active': '' "
  >
    <button
      class="flex items-center text-sm"
      @click="toggleMenu()"
    >
      <span class="mr-2">
        <aw-icon
          :icon="openMenu ? 'close' : 'hamburger'"
          class="w-4 h-4"
          :class="{
            '': iconFillCurrent,
            '': !iconFillCurrent
          }"
        ></aw-icon>
      </span>
      <span class="flex-grow">{{ title }}</span>
    </button>
  </li>
</template>

<script>
import useBcMenu from '@/frontapp/store/bcMenu'
import { mapStores } from 'pinia'

export default {
  name: 'MenuLeftNavItem',
  props: {
    iconFillCurrent: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data () {
    return {
      openMenu: false,
    }
  },
  computed: {
    title() {
      if (this.openMenu){
        return this.$t('Close menu')
      } else {
        return this.$t('Open menu')
      }
    },
    ...mapStores(useBcMenu)
  },
  watch: {
    'bcMenuStore.desktopNavMenu' (newVal) {
      if (newVal) {
        this.openMenu = true
      } else {
        this.openMenu = false
      }
    }
  },
  methods: {
    toggleMenu() {
      this.openMenu = !this.openMenu
      if (this.openMenu) {
        this.bcMenuStore.openDesktopNavMenu()
        this.$el.parentElement.parentElement.parentElement.style.setProperty('--document-el-height', document.documentElement.offsetHeight + 'px');
      } else {
        this.bcMenuStore.closeDesktopNavMenu()
      }
    }
  }
}
</script>
